<template>
  <footer class="footer">
    <div class="container" :class="{ 'container--en': isEn }">
      <div class="footer-content" :class="{ 'is-en': isEn }">
        <div class="footer-info" :class="{ 'is-en': isEn }">
          <p class="footer-name" :class="{ 'is-en': isEn }" style="font-size: var(--text-h3);font-weight: var(--text-h3-weight); margin-bottom: 20px;opacity: 1;">{{ $t('footer.company') }}</p>
          <p class="footer-address">{{ $t('footer.address') }}</p>
        </div>
        <div class="footer-links">
          <div class="footer-link-col">
            <p class="footer-link-title">{{ $t('footer.productCenter') }}</p>
            <p class="footer-link-item">{{ $t('footer.productOutbound') }}</p>
            <p class="footer-link-item">{{ $t('footer.productInbound') }}</p>
          </div>
          <div class="footer-link-col">
            <p class="footer-link-title">{{ $t('footer.scenarioTitle') }}</p>
            <p class="footer-link-item">{{ $t('footer.scenarioGovernment') }}</p>
            <p class="footer-link-item">{{ $t('footer.scenarioLegal') }}</p>
            <p class="footer-link-item">{{ $t('footer.scenarioCar') }}</p>
          </div>
        </div>
        <div class="footer-qrcodes">
          <div class="footer-qrcode">
            <img src="@/assets/home/qiWchart.png" :alt="$t('common.altWechatWork')" />
            <p>{{ $t('footer.wechatWork') }}</p>
          </div>
          <div class="footer-qrcode">
            <img src="@/assets/home/qrCode.png" :alt="$t('common.altOfficial')" />
            <p>{{ $t('footer.wechatOfficial') }}</p>
          </div>
        </div>
      </div>
      <div class="footer-copyright">
        <p>{{ $t('footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    isEn() {
      return this.$i18n.locale === 'en'
    }
  }
}
</script>

<style scoped>
.footer {
  padding: var(--sp-15) 0 var(--sp-5);
  background: #000000;
  color: var(--c-white);
}
.container {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 var(--container-padding);
}
.container--en {
  max-width: var(--container-max);
}
.footer-info {
  margin-right: auto;
}
.footer-content {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 30px;
  margin-bottom: var(--sp-10);
}
.footer-info p {
  font-size: var(--fs-base);
  margin-bottom: var(--sp-3);
  opacity: 0.8;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  font-family: var(--font-base);
}
.footer-info.is-en {
  max-width: 360px;
  flex-shrink: 1;
}
.footer-content.is-en {
  gap: 20px;
}

@media (min-width: 1025px) {
  .footer-content.is-en {
    flex-wrap: nowrap;
  }
}
.footer-content.is-en .footer-links {
  margin-right: 0;
}
.footer-info.is-en {
  max-width: none;
  flex-shrink: 1;
}
.footer-info.is-en p {
  flex-wrap: wrap;
}
.footer-name.is-en {
  font-size: var(--fs-lg) !important;
}
.footer-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  flex-shrink: 0;
}
.footer-links {
  display: flex;
  gap: var(--sp-15);
  margin-right: var(--sp-10);
}
.footer-link-col {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}
.footer-link-title {
  font-size: var(--fs-md);
  font-weight: var(--fw-medium);
  font-family: var(--font-base);
  margin-bottom: 4px;
}
.footer-link-item {
  font-size: var(--fs-md);
  font-weight: var(--fw-light);
  font-family: var(--font-base);
  opacity: 0.8;
}
.footer-qrcodes {
  display: flex;
  gap: var(--sp-5);
  justify-content: center;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.footer-qrcode {
  text-align: center;
}
.footer-qrcode img {
  width: 120px;
  height: 120px;
  margin-bottom: var(--sp-3);
  background: var(--c-white);
  padding: var(--sp-2);
}
.footer-qrcode p {
  font-size: var(--fs-sm);
  font-family: var(--font-base);
  opacity: 0.7;
}
.footer-copyright {
  text-align: center;
  padding-top: var(--sp-5);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: var(--fs-sm);
  font-family: var(--font-base);
  opacity: 0.6;
}

@media (max-width: 1024px) {
  .footer-content.is-en {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .footer-content.is-en .footer-info {
    margin-right: 0;
  }
}
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .footer-info {
    margin-right: 0;
  }
  .footer-links {
    margin-right: 0;
    gap: var(--sp-10);
  }
}
@media (max-width: 480px) {
  .footer {
    padding: var(--sp-10) 0 var(--sp-4);
  }
  .footer-name {
    font-size: var(--fs-h3) !important;
  }
  .footer-link-title,
  .footer-link-item {
    font-size: var(--fs-sm);
  }
  .footer-qrcodes {
    flex-direction: column;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue